module.exports = __webpack_public_path__ + "static/media/CostSaving.67604848.svg";